import z from 'zod';

export const authorizeUrlModel = z.object({
    authorizationUrl: z.string().url(),
});

export const openIdConnectConfigurationModel = z.object({
    audience: z.string(),
    authority: z.string(),
    authorizationEndpoint: z.string(),
    clientId: z.string().min(1),
    endSessionEndpoint: z.string(),
    issuer: z.string(),
    jwksUri: z.string(),
    redirectUri: z.string(),
    responseType: z.string(),
    scopes: z.string(),
    tokenEndpoint: z.string(),
});

export const authorizationSettingsModel = z.object({
    openIdConnectConfiguration: z
        .union([authorizeUrlModel, openIdConnectConfigurationModel])
        .nullable(),
    openIdConnectEnabled: z.boolean(),
    subDomain: z.string().nullable(),
    type: z.string().nullable(),
});

export type AuthorizationSettings = z.infer<typeof authorizationSettingsModel>;
